export default __webpack_public_path__ + "static/media/prensesselin5.89b2ebf6.jpg";